import React from "react";
import {
  FaFacebookF,
  FaPinterest,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
  FaFonticonsFi
} from "react-icons/fa";
import Typical from "react-typical";
import AOS from "aos";
import "aos/dist/aos.css";

const Banner = () => {
  AOS.init();
  const [state] = React.useState({
    title: "USMAN ALI",
    image: "/images/1.1.png",
  });
  return (
    <header className="header">
      <div className="container">
        <div className="row">
          <div className="col-6">
            <div className="header__content">
              <div className="header__section">
                <ul className="header__ul">
                  <li data-aos="fade-down-right">
                    <a
                      href="https://www.facebook.com/profile.php?id=100027146681035"
                      target="_blank"
                    >
                      <FaFacebookF className="headerIcon" />
                    </a>
                  </li>
                  <li data-aos="fade-down-right">
                    <a
                      href="https://www.linkedin.com/in/usman-mirza/"
                      target="_blank"
                    >
                      <FaLinkedinIn className="headerIcon" />
                    </a>
                  </li>
                  <li data-aos="fade-down-right">
                    <a href="https://github.com/Uxmanmirza" target="_blank">
                      <FaGithub className="headerIcon" />
                    </a>
                  </li>
                  <li data-aos="fade-down-right">
                    <a
                      href="https://www.instagram.com/mughal.uxman/"
                      target="_blank"
                    >
                      <FaInstagram className="headerIcon" />
                    </a>
                  </li>
                  <li data-aos="fade-down-right">
                    <a
                      href="https://www.fiverr.com/usmanali0982/build-responsive-web-applications-using-react-js"
                      target="_blank"
                    >
                      <FaFonticonsFi className="headerIcon" />
                    </a>
                  </li>
                </ul>
                <h1>{state.title}</h1>
                <h2>
                  <Typical
                    loop={Infinity}
                    steps={[
                      "Front End Dev 💻",
                      1000,
                      "Microbiologist 🧫",
                      1000,
                      "MERN Stack Dev 😎",
                      1000,
                      "Scientist 🥼",
                      1000,
                      "React Native Dev 📱",
                      1000,
                    ]}
                  />
                </h2>
                <div className="header__buttons" data-aos="flip-up">
                  <a
                    href="/images/USMAN-ALI-CV.pdf"
                    download="USMAN ALI CV USMAN-ALI-CV.pdf"
                    className="btn btn-outline"
                  >
                    Download CV
                  </a>
                  &nbsp;&nbsp;&nbsp;
                </div>
                <div className="header__buttons1" data-aos="flip-up"> 
                  <a href="https://usmanportfolio.carrd.co/" className="btn btn-outline" target="_blank">
                    Projects
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="banner__img">
              <img src={state.image} alt="man" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Banner;
